import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-reply",
  "use": "icon-reply-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-reply\"><defs><style></style></defs><path d=\"M341.333 938.667v-128H128v-640h768v640H554.667l-213.334 128zM170.667 768H384v95.147L542.72 768h310.613V213.333H170.667V768z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol